import { useEffect, useState, forwardRef } from "react";

import placeHolder from "../../../assets/images/frenchtech_placeholder.jpg";

const InstitutionItem = forwardRef(
  (
    {
      etablissement,
      selectedInstitution,
      setSelectedInstitution,
      filters,
      setMapScreen,
      scrollbarRef,
      allEtablissements,
      filtersKeys,
    },
    ref
  ) => {
    const [isSelected, setIsSelected] = useState(false);

    //--- Get overlayScrollbar Instance from the parent component
    let scrollbarInstance = {};
    if (scrollbarRef.current) {
      scrollbarInstance = scrollbarRef.current.osInstance();
    }

    //--- Scroll the selected institution to the top
    const scrollTo = (etablissementArray, idToCompare, e) => {
      const i = etablissementArray.findIndex((elt) => elt.id === idToCompare);
      const { viewport } = scrollbarInstance.elements();
      viewport.scrollTo({
        top: e.currentTarget.offsetTop,
        behavior: "smooth",
      });
    };

    //--- Control if current item is active or not
    useEffect(() => {
      if (selectedInstitution) {
        if (selectedInstitution.id === etablissement.id) {
          setIsSelected(true);
          document.body.classList.add("no-scroll");
          setMapScreen(true);
        } else {
          setIsSelected(false);
        }
      } else {
        setIsSelected(false);
      }
    }, [selectedInstitution]);

    //--- Trigger auto-scroll, set the selected item state
    const handleShowInstitution = (etablissement, e) => {
      scrollTo(allEtablissements, etablissement.id, e);
      setSelectedInstitution((prev) => {
        if (prev) {
          if (prev.id === etablissement.id) {
            return null;
          } else {
            return etablissement;
          }
        } else {
          return etablissement;
        }
      });
    };

    //--- Create a list of icons composed of the type of activity the entity has
    const iconList = [];
    // for (const category of etablissement[Object.keys(filters)[1]]) {
    //   for (const cat of filters[Object.keys(filters)[1]].values) {
    //     if (category === cat.slug) {
    //       iconList.push(cat.icon);
    //     }
    //   }
    // }

    //     let typeComponent = [];
    //     for (const element of etablissement[Object.keys(filters)[1]]) {
    //       for (const filter of filters[Object.keys(filters)[1]].values) {

    //         if (element === filter.slug) {
    //          {typeComponent.push(<span style={{marginRight:'5px'}}>{element}</span>)}
    //         }
    //       }
    //     }
    // console.log(typeComponent);

    // const typeComponent = etablissement[Object.keys(filters)[1]].map((item, index) => {
    //   for (const filter of filters[Object.keys(filters)[1]].values) {
    //     if (item === filter.slug) {
    //       return (
    //         <span key={index} style={{ marginRight: "5px" }}>
    //           {item}
    //         </span>
    //       );
    //     }
    //   }
    // });

    let colorsArray = [];
    //--- Create Array of colors looping on first filter key
    // for (const element of etablissement[Object.keys(filters)[0]]) {
    //   for (const filter of filters[Object.keys(filters)[0]].values) {
    //     if (element === filter.slug) {
    //       colorsArray.push(filter.color);
    //     }
    //   }
    // }

    //--- Create the color bands depending on the colors Array created above
    // const colorBands = colorsArray.map((color, index) => {
    //   return (
    //     <span
    //       key={color + index}
    //       style={{ display: "inline-block", width: "50px", height: "5px", backgroundColor: `${color}` }}
    //     ></span>
    //   );
    // });

    return (
      <div
        className={`inst-item ${isSelected ? "active " : ""}d-flex`}
        key={etablissement.id}
        onClick={(e) => handleShowInstitution(etablissement, e)}
        ref={ref}
      >
        <div className="inst-item__img-wrapper">
          <img
            // src={etablissement.picture ? etablissement.picture : placeHolder}
            src={etablissement.picture}
            alt="picture"
            width="70"
            height="70"
          />
        </div>
        <div className="d-flex flex-column">
          {/* <div className="d-flex inst-item__color-band ">{colorBands}</div> */}
          <div className="pb-2 pr-3">
            <div
              className={`inst-item__name ${
                etablissement?.activity.indexOf("produit") !== -1 ||
                etablissement?.activity.indexOf("products") !== -1
                  ? "item-contact"
                  : ""
              }`}
            >
              {etablissement.name}
            </div>
            <div className="inst-item__address">{etablissement.address}</div>
            {/* <div className="inst-item__svg-list">{typeComponent}</div> */}
          </div>
        </div>
      </div>
    );
  }
);

export default InstitutionItem;
